<script setup lang="ts">
import type { Component } from "vue"
import { ref, h } from "vue"
import { ArrowDown } from '@element-plus/icons-vue'

const props = defineProps<{
  teams: {
    name: string
    logo: Component
    plan: string
  }[]
  collapsed?: boolean
}>()

const activeTeam = ref(props.teams[0])
</script>

<template>
  <el-dropdown trigger="click" placement="bottom-start" @command="(team: typeof props.teams[number]) => activeTeam = team">
    <div class="flex items-center gap-2 cursor-pointer p-2 rounded-lg transition-colors" style="background-color: transparent;">
      <div class="flex aspect-square size-8 items-center justify-center rounded-lg" style="background-color: hsl(var(--sidebar-primary)); color: hsl(var(--sidebar-primary-foreground));">
        <component :is="h(activeTeam.logo)" class="size-4" />
      </div>
      <div v-if="!collapsed" class="flex-1 text-left min-w-0">
        <div class="text-sm font-semibold truncate">{{ activeTeam.name }}</div>
        <div class="text-xs opacity-70 truncate">{{ activeTeam.plan }}</div>
      </div>
      <el-icon v-if="!collapsed">
        <ArrowDown />
      </el-icon>
    </div>
    <template #dropdown>
      <el-dropdown-menu>
        <el-dropdown-item
          v-for="(team, index) in teams"
          :key="team.name"
          :command="team"
        >
          <div class="flex items-center gap-2">
            <div class="flex size-6 items-center justify-center rounded-sm border">
              <component :is="h(team.logo)" class="size-4 shrink-0" />
            </div>
            <span>{{ team.name }}</span>
          </div>
        </el-dropdown-item>
      </el-dropdown-menu>
    </template>
  </el-dropdown>
</template>
